import styled from "styled-components";

export const WrapperContent = styled.div`
    position: fixed;
    top: ${props => props.contentMarginTop+"px"} ;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: ${({theme}) => theme.zIndex.contentFixed};
    overflow: scroll;
    overscroll-behavior: contain;
    padding-bottom: 6.625rem;
    background-color: ${({ theme }) => theme.color.white};
`;